module.exports = __webpack_public_path__ + "static/img/reserve.74c2c3dc.png";